import {DICCIONARIO} from '../../../constants/Diccionario'
import {REGEX_SERIE, REGEX_TELEFONO} from '../../../constants/Regex'
import {validacionFechaMenorIgual} from '../../../utils/stringDate'
import * as validacionesRegex from '../../../utils/strings.utils'
import * as validators from '../../../utils/validaciones'
import {
  diagnosticarCodigoEstablecimientoV2,
  diagnosticarPuntoVentaV2,
} from '../../../utils/series.utils'

export const validacionesHandleChangeFacturador = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'username':
        if (!validacionesRegex.validarRegexUsername(value)) return false
        break
      case 'passwd':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      case 'passwd2':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      case 'birth_date':
        break
      case 'first_name':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'second_name':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'third_name':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'last_name':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'last_name2':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'last_name_married':
        if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return false
        break
      case 'nit':
        if (!validacionesRegex.validarRegexNumEnteroGuion(value)) return false
        break
      case 'id_number':
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return false
        break
      case 'codigo_empresa':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return false
        break
      case 'email':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      case 'phone_number':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      case 'location':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurFacturador = (name: string, value: string, tipoDoc: string = '') => {
  let message = ''
  switch (name) {
    case 'username':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.USERNAME)
      if (!message) message = validators.validacionMinLenght(value, message, 2)
      break
    case 'birth_date':
      message = validators.validacionEsRequerido(
        value,
        message,
        DICCIONARIO.FECHA_NACIMIENTO,
        'requerida'
      )
      if (!message)
        message = validators.validacionFechaNacMayor17(value, message, DICCIONARIO.FECHA_NACIMIENTO)
      if (!message) message = validacionFechaMenorIgual(value, DICCIONARIO.FECHA_NACIMIENTO, 150)
      break
    case 'first_name':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRIMER_NOMBRE)
      break
    case 'second_name':
      break
    case 'third_name':
      break
    case 'last_name':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRIMER_APELLIDO)
      break
    case 'last_name2':
      break
    case 'last_name_married':
      break
    case 'id_number':
      value = String(value).toUpperCase()
      message = validators.validacionEsRequerido(value, message, tipoDoc)

      switch (tipoDoc) {
        case 'DUI':
          value = value.substring(0, 9);
          break;
      }

      if (!message) message = validators.validarTipoDocumento(tipoDoc, value, message)
      break
    case 'email':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.EMAIL)
      if (!message) message = validators.validacionEmail(value, message, DICCIONARIO.EMAIL)
      break
    case 'phone_number':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.TELEFONO)
      if (!message) message = validators.validacionMinLenght(value, message, 8)
      if (!message)
        message = validators.validacionRegex(REGEX_TELEFONO, value, message, DICCIONARIO.TELEFONO)
      break
    case 'location':
      break
    case 'tipoDocumento':
      message = validators.validacionEsRequerido(
        value,
        message,
        DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION
      )
      break
    default:
      break
  }
  return message
}

export const validacionesCodigoHandleChangeFacturador = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'code':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesCodigoOnBlurFacturador = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'code':
      message = validators.validacionEsRequerido(value, message, 'Código de verificación')
      break
    default:
      break
  }
  return message
}

export const validacionesHandleChangeDocumento = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'nombre':
        if (!validacionesRegex.validarRegexLetrasEspaciosNums(value)) return false
        break
      case 'serie':
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return false
        break
      case 'codigo':
        if (!validacionesRegex.validarRegexAlfaNum(value)) return false
        break
      case 'descripcion':
        if (!validacionesRegex.validarRegexLetrasEspaciosNums(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurDocumento = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'nombre':
      message = validators.validacionEsRequerido(value, message, 'Nombre de usuario')
      if (!message) message = validators.validacionMinLenght(value, message, 2)
      break
    case 'serie':
      message = validators.validacionEsRequerido(value, message, 'Serie', 'requerida')
      if (!message) message = validators.validacionRegex(REGEX_SERIE, value, message, 'Serie')
      break
    case 'codigo':
      message = validators.validacionEsRequerido(value, message, 'codigo', 'requerida')
      break
    case 'descripcion':
      message = validators.validacionEsRequerido(value, message, 'Descripción', 'requerida')
      break
    default:
      break
  }
  return message
}

export const validacionesHandleChangeSucursal = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'nombre':
        if (!validacionesRegex.validarAlfanumericoEspacios(value)) return false
        break

      case 'codigo':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return false
        break

      case 'descripcion':
      case 'direccion':
        if (!validacionesRegex.validarAlfanumConEspeciales(value)) return false
        break

      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurSucursal = (
  name: string,
  value: string,
  normativaV2: boolean = false
) => {
  let message = ''
  switch (name) {
    case 'nombre':
      message = validators.validacionEsRequerido(value, message, 'Nombre de sucursal')
      break

    case 'codigo':
      message = validators.validacionEsRequerido(value, message, 'Código')
      if (!message) message = validators.validacionMinLenght(value, message, 4)
      if (!message && normativaV2) message = diagnosticarCodigoEstablecimientoV2(value)
      break

    case 'descripcion':
      if (value) message = validators.validacionMinLenght(value, message, 4)
      break

    case 'direccion':
      message = validators.validacionEsRequerido(value, message, 'Dirección')
      if (!message) message = validators.validacionMinLenght(value, message, 8)
      break

    default:
      break
  }
  return message
}

export const validacionesOnBlurDocumentoSucursal = (
  name: string,
  value: string,
  normativaV2: boolean = false
) => {
  let message = ''
  switch (name) {
    case 'idsucursal':
      message = validators.validacionEsRequerido(value, message, 'Sucursal', 'requerida')
      break

    case 'documento':
      message = validators.validacionEsRequerido(value, message, 'Tipo de documento')
      break

    case 'resolucion':
      message = validators.validacionEsRequerido(value, message, 'Resolución', 'requerida')
      if (!message) message = validators.validacionMinLenght(value, message, 10)
      break

    case 'codigoSucursal':
      message = validators.validacionEsRequerido(value, message, 'Código de sucursal')
      if (!message) message = validators.validacionMinLenght(value, message, 4)
      if (!message && normativaV2) {
        const diagnostico = diagnosticarCodigoEstablecimientoV2(value)
        if (diagnostico) {
          message = `${diagnostico} Corrija el código de la sucursal antes de agregar el documento.`
        }
      }
      break

    case 'numeroSucursal':
      message = validators.validacionEsRequerido(value, message, 'Número')
      if (!message) message = validators.validacionMinLenght(value, message, 4)
      if (!message && normativaV2) message = diagnosticarPuntoVentaV2(value)
      break

    default:
      break
  }
  return message
}

export const validacionesHandleChangeDocSucursal = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'numeroSucursal':
        if (!validacionesRegex.validarAlfanumerico(value)) return
        break

      case 'resolucion':
        value = value.toUpperCase()
        if (!validacionesRegex.validarAlfanumConEspeciales(value)) return
        break
    }
  }
  return value
}


export const validacionesHandleChangeGeneral = (name: string, value: string, tipoDocumento: string = "") => {
  if (value) {
    switch (name) {
      case 'numId':
        if((tipoDocumento === "36" || tipoDocumento === "13") && !validacionesRegex.validarRegexNumericoInt(value) ) return
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return
        break
      case 'nombre':
        if (!validacionesRegex.validarRegexNombresCliente(value)) return
        break
      default:
        break
    }
  }
  return true
}

export const validacionesOnBlurGeneral = (name: string, value: string, nombreTipoDocumento: string = '') => {
  let message = ''
  switch (name) {
    case 'tipoDocumento':
      message = validators.validacionEsRequerido(value, message, 'Tipo de documento de identificación')
      break
    case 'numId':
      message = validators.validacionEsRequerido( value, message, nombreTipoDocumento)
      if (!message) message = validators.validacionMinLenght(value, message, 3)
      if (!message) message = validators.validarTipoDocumento(nombreTipoDocumento!, value, message)
      break
    case 'nombre':
      message = validators.validacionEsRequerido(value, message, 'Nombre')
      break
    default:
      break
  }
  return message
}

export const handleChangeDocumentoFisico = (name: string, value: string) => {
  if (value) {
    switch (name) {
      case 'numId':
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return false
        value = value.toUpperCase();
        break
      case 'descripcion':
        if (!validacionesRegex.validarRegexLetras(value)) return false
        break
      case 'monto':
        if (!validacionesRegex.validarRegexNumericoFloat2Decimales(value)) return false
        break
      default:
        break
    }
  }
  return true
}

export const onBlurDocumentoFisico = (name: string, value: string) => {
  let message = ''
  switch (name) {
    case 'tipo':
      message = validators.validacionEsRequerido(value, message, DICCIONARIO.TIPO_DTE)
      break
    case 'numId':
      message = validators.validacionEsRequerido(value, message, "Número de documento")
      if (!message) message = validators.validacionRegex(REGEX_SERIE, value, message, 'Número de documento')
      if (!message) message = validators.validacionMaxLenght(value, message, 20)
      break
    case 'fecha':
      message = validators.validacionEsRequerido(value, message, "Fecha de generación")
      break
    case 'descripcion':
      message = validators.validacionMaxLenght(value, message, 50)
      break
    case 'monto':
      message = validators.validacionEsRequerido(value, message, "Monto")
      if (!message) message = validators.validacionNumMinimo(value, 0)
      if (!message) message = validators.validacionNumMaximo(value, 100000000000)
      break
    default:
      break
  }
  return message
}